function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentCreditCardRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 20a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.5 20zm5 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112.5 20zM2 25c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V14H2v11zM28 5H4c-1.1 0-2 .9-2 2v3h28V7c0-1.1-.9-2-2-2z",
    fill: props.color
  }));
}

export default SvgIconPaymentCreditCardRexFilled;